import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, MapPin } from "lucide-react";
import client from "../lib/api";
import { Crest, SectionTitle, Loading, Card, Pill } from "../components/common";

export default function FixturesPage() {
  const [fixtures, setFixtures] = useState(null);
  useEffect(() => { client.get("/fixtures").then((r) => setFixtures(r.data)).catch(() => setFixtures([])); }, []);
  if (!fixtures) return <Loading />;
  const weeks = [...new Set(fixtures.map((f) => f.matchweek))].sort((a, b) => b - a);
  return (
    <div data-testid="fixtures-page">
      <SectionTitle kicker="Matchday">Fixtures & Results</SectionTitle>
      {weeks.map((w) => (
        <div key={w} className="mb-8">
          <h3 className="font-head font-bold text-green mb-3 flex items-center gap-2"><span className="bg-gold text-ink px-2 py-0.5 rounded-sm text-sm">Matchweek {w}</span></h3>
          <div className="grid sm:grid-cols-2 gap-3">
            {fixtures.filter((f) => f.matchweek === w).map((f) => (
              <Link to={`/match/${f.id}`} key={f.id} data-testid={`fixture-${f.id}`}>
                <Card className="p-4">
                  <div className="flex items-center justify-between text-xs text-ink/50 mb-3">
                    <span className="flex items-center gap-1"><MapPin size={12} />{f.venue}</span>
                    {f.status === "FT" ? <Pill tone="muted">Full time</Pill> : <span className="flex items-center gap-1"><Clock size={12} />{new Date(f.kickoff).toLocaleString("en-GB",{weekday:"short",day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}</span>}
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="flex-1 flex items-center gap-2 font-semibold"><Crest slug={f.home_slug} name={f.home_name} size={30} /><span className="truncate">{f.home_name}</span></div>
                    <div className="font-head font-black text-xl text-green tabular px-2">{f.status === "FT" ? `${f.home_score} - ${f.away_score}` : "v"}</div>
                    <div className="flex-1 flex items-center gap-2 font-semibold justify-end"><span className="truncate text-right">{f.away_name}</span><Crest slug={f.away_slug} name={f.away_name} size={30} /></div>
                  </div>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
